module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "canvasBlock group row relative"
  }, [_c('transition', {
    attrs: {
      "leave-active-class": "animated fadeOut"
    }
  }, [(!_vm.loadingComplete) ? _c('div', {
    staticClass: "loadingBlock"
  }, [_c('div', {
    staticClass: "center-align-ab"
  }, [_c('center', [_c('FulfillingBouncingCircleSpinner', {
    attrs: {
      "animation-duration": 2500,
      "size": 45,
      "color": '#232F4B'
    }
  })], 1), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "loadingText"
  }, [_vm._v(_vm._s(_vm.loadingStatus))])], 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInDown"
    }
  }, [(_vm.loadingComplete && _vm.$store.state.mode === 'editor') ? _c('div', {
    staticClass: "secondary-nav primarybgdark m-b-20"
  }, [_c('div', {
    staticClass: "btn-group m-b-10 m-r-5"
  }, [_c('button', {
    staticClass: "btn btn-success dropdown-toggle waves-effect waves-light",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(9)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(9)
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus m-r-5"
  }), _vm._v(" Add "), _c('span', {
    staticClass: "icon-arrow-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'text'
        })
      }
    }
  }, [_vm._v("Text "), _c('span', [_vm._v("(⌘ + 1)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'rect',
          custom: {
            name: 'New Rectangle'
          }
        })
      }
    }
  }, [_vm._v("Block "), _c('span', [_vm._v("(⌘ + 2)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'ellipse',
          custom: {
            name: 'New Ellipse'
          }
        })
      }
    }
  }, [_vm._v("Ellipse "), _c('span', [_vm._v("(⌘ + 3)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'triangle',
          custom: {
            name: 'New Triangle'
          }
        })
      }
    }
  }, [_vm._v("Triangle "), _c('span', [_vm._v("(⌘ + 4)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'image'
        })
      }
    }
  }, [_vm._v("Image "), _c('span', [_vm._v("(⌘ + 5)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'clipping-area',
          custom: {
            name: 'Clipping Area',
            type: 'clipping-mask'
          }
        })
      }
    }
  }, [_vm._v("Mask - Box "), _c('span', [_vm._v("(⌘ + 6)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'round-clipping-area',
          custom: {
            name: 'Clipping Area',
            type: 'clipping-mask'
          }
        })
      }
    }
  }, [_vm._v("Mask - Circle "), _c('span', [_vm._v("(⌘ + 7)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group m-b-10 m-r-5"
  }, [_c('button', {
    staticClass: "btn primarybg dropdown-toggle waves-effect waves-light",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [_vm._v("Zoom: " + _vm._s(_vm.zoom * 100 + '%') + " "), _c('span', {
    staticClass: "icon-arrow-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(1)
      }
    }
  }, [_vm._v("100%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.9)
      }
    }
  }, [_vm._v("90%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.8)
      }
    }
  }, [_vm._v("80%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.7)
      }
    }
  }, [_vm._v("70%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.6)
      }
    }
  }, [_vm._v("60%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.5)
      }
    }
  }, [_vm._v("50%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.4)
      }
    }
  }, [_vm._v("40%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.3)
      }
    }
  }, [_vm._v("30%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.2)
      }
    }
  }, [_vm._v("20%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.1)
      }
    }
  }, [_vm._v("10%")])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover m-b-10 m-r-5",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(10)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(10)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.removeElement()
      }
    }
  }, [_c('i', {
    staticClass: "icon-bin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-group m-b-10 m-r-5"
  }, [_c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(0)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(0)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.groupAlign('left')
      }
    }
  }, [_c('i', {
    staticClass: "icon-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(1)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(1)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.groupAlign('center')
      }
    }
  }, [_c('i', {
    staticClass: "icon-align-center-horizontal"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(2)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(2)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.groupAlign('right')
      }
    }
  }, [_c('i', {
    staticClass: "icon-align-right"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(3)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(3)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.groupAlign('top')
      }
    }
  }, [_c('i', {
    staticClass: "icon-align-top"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(26)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(26)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.groupAlign('vertical-center')
      }
    }
  }, [_c('i', {
    staticClass: "icon-align-center-vertical"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(4)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(4)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.groupAlign('bottom')
      }
    }
  }, [_c('i', {
    staticClass: "icon-align-bottom"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group m-b-10 m-r-5"
  }, [_c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(27)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(27)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.evenlySpace('horizontal')
      }
    }
  }, [_c('i', {
    staticClass: "icon-menu"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(28)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(28)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.evenlySpace('vertical')
      }
    }
  }, [_c('i', {
    staticClass: "icon-more2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group m-b-10 m-r-5"
  }, [_c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(29)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(29)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.flipX(null)
      }
    }
  }, [_c('i', {
    staticClass: "icon-flip-horizontal"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(30)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(30)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.flipY(null)
      }
    }
  }, [_c('i', {
    staticClass: "icon-flip-vertical"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group m-b-10 m-r-5"
  }, [_c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(5)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(5)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.moveLayer(null, 'front')
      }
    }
  }, [_c('i', {
    staticClass: "icon-angle-double-up m-r-5"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(6)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(6)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.moveLayer(null, 'forward')
      }
    }
  }, [_c('i', {
    staticClass: "icon-angle-up m-r-5"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(7)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(7)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.moveLayer(null, 'backward')
      }
    }
  }, [_c('i', {
    staticClass: "icon-angle-down m-r-5"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(8)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(8)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.moveLayer(null, 'back')
      }
    }
  }, [_c('i', {
    staticClass: "icon-angle-double-down m-r-5"
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInDown",
      "leave-active-class": "animated fadeOutDown"
    }
  }, [(_vm.tooltip !== null) ? _c('p', {
    staticClass: "right primarytextlight"
  }, [_vm._v("\n                    " + _vm._s(_vm.tooltip) + "\n                ")]) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 m-b-20 artboardWrapper",
    class: {
      fullArtboard: (_vm.displayType === 'preview'), artboard: true, 'designMode': _vm.displayType === 'designer', 'editMode': _vm.displayType === 'editor'
    }
  }, [_c('div', {
    staticClass: "containerWrapper"
  }, [_c('canvas', {
    directives: [{
      name: "insert-message",
      rawName: "v-insert-message",
      value: (_vm.exampleContent),
      expression: "exampleContent"
    }],
    staticStyle: {
      "width": "100%",
      "height": "635px",
      "border": "1px solid #BBB"
    },
    attrs: {
      "id": "canvas",
      "width": _vm.productPixelWidth,
      "height": _vm.productPixelHeight
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.displayType !== 'preview') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.template.userversions === undefined || _vm.$store.state.template.userversions.data.length < 1 || _vm.$store.state.savedTemplate !== null || _vm.newTemplate === true || _vm.$store.state.mode === 'editor'),
      expression: "$store.state.template.userversions === undefined || $store.state.template.userversions.data.length < 1 || $store.state.savedTemplate !== null || newTemplate === true || $store.state.mode === 'editor'"
    }],
    staticClass: "panel-group panel-group-joined layers col-sm-4 right",
    class: {
      'designMode': _vm.displayType === 'designer', 'editMode': _vm.displayType === 'editor'
    },
    attrs: {
      "id": "accordion-test"
    }
  }, [(_vm.noEditableLayers === true) ? _c('div', {
    staticClass: "noEdit m-b-20"
  }, [_vm._v("\n                This template has no layers to edit, please proceed below.\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.canvasDataReverse), function(shape, index) {
    return (
      shape.custom === undefined ||
      (_vm.displayType === 'designer' && shape.type !== 'rect' && shape.type !== 'ellipse' && shape.type !== 'triangle' && shape.custom.editable === true) ||
      (_vm.displayType === 'editor' && shape.custom !== undefined && shape.custom.name !== 'Trim Area' && shape.custom.name !== 'Safe Area')
    ) ? _c('div', {
      staticClass: "panel panel-default"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.loadingComplete),
        expression: "loadingComplete"
      }],
      staticClass: "collapsed",
      class: {
        'confirmed': (shape.custom.confirmed === true)
      },
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion-test",
        "href": ['#collapse' + index],
        "aria-expanded": "false"
      },
      on: {
        "click": function($event) {
          _vm.setActiveObject(index)
        }
      }
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h4', {
      staticClass: "panel-title"
    }, [(shape.type === 'textbox') ? _c('i', {
      staticClass: "icon-format m-r-5"
    }) : (shape.custom.type === 'clipping-mask') ? _c('i', {
      staticClass: "icon-crop m-r-5"
    }) : (shape.type === 'rect') ? _c('i', {
      staticClass: "icon-shapes m-r-5"
    }) : (shape.type === 'ellipse') ? _c('i', {
      staticClass: "icon-shapes m-r-5"
    }) : (shape.type === 'triangle') ? _c('i', {
      staticClass: "icon-shapes m-r-5"
    }) : (shape.type === 'image') ? _c('i', {
      staticClass: "icon-image m-r-5"
    }) : _vm._e(), _vm._v(" "), ((shape.type === 'textbox') && (shape.custom && shape.custom.name === '')) ? _c('span', [_vm._v(_vm._s(shape.text))]) : (shape.custom) ? _c('span', [_vm._v(_vm._s(shape.custom.name))]) : (shape._originalElement && shape._originalElement.currentSrc) ? _c('span', [_vm._v(_vm._s(_vm._f("shortenUrl")(shape._originalElement.currentSrc)))]) : _vm._e(), _vm._v(" "), _c('transition-group', {
      attrs: {
        "enter-active-class": "animated fadeInRight",
        "leave-active-class": "animated fadeOut"
      }
    }, [(shape.custom.confirmed === true) ? _c('i', {
      key: "1",
      staticClass: "icon-checkmark-circle right"
    }) : _vm._e(), _vm._v(" "), (shape.custom.locked === true && _vm.displayType === 'editor') ? _c('i', {
      key: "2",
      staticClass: "icon-lock right"
    }) : _vm._e(), _vm._v(" "), (shape.custom.editable === false && _vm.displayType === 'editor') ? _c('i', {
      key: "3",
      staticClass: "icon-no-edit right"
    }) : _vm._e(), _vm._v(" "), (shape.visible === false) ? _c('i', {
      key: "4",
      staticClass: "icon-eye-blocked right"
    }) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "panel-collapse collapse",
      staticStyle: {
        "height": "0px"
      },
      attrs: {
        "id": ['collapse' + index],
        "aria-expanded": "false"
      }
    }, [(shape.type === 'textbox') ? _c('div', {
      staticClass: "panel-body"
    }, [(_vm.displayType === 'editor') ? _c('div', [_c('div', {
      staticClass: "btn-group m-r-5"
    }, [_c('editable', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(11)
        },
        "editable": function($event) {
          _vm.editable(index)
        }
      }
    }), _vm._v(" "), _c('visible', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(12)
        },
        "visible": function($event) {
          _vm.visible(index)
        }
      }
    }), _vm._v(" "), _c('lock', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(13)
        },
        "lock": function($event) {
          _vm.lock(index)
        }
      }
    })], 1), _vm._v(" "), _c('copy', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(21)
        },
        "clone": function($event) {
          _vm.clone()
        }
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "btn-group m-r-5"
    }, [_c('italic', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(14)
        },
        "italic": function($event) {
          _vm.fontItalic(index)
        }
      }
    }), _vm._v(" "), _c('bold', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(15)
        },
        "bold": function($event) {
          _vm.fontBold(index)
        }
      }
    }), _vm._v(" "), _c('underline', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(16)
        },
        "underline": function($event) {
          _vm.fontUnderline(index)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "btn-group m-r-5"
    }, [_c('alignLeft', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(17)
        },
        "textAlign": function($event) {
          _vm.textAlign(index, 'left')
        }
      }
    }), _vm._v(" "), _c('alignCenter', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(18)
        },
        "textAlign": function($event) {
          _vm.textAlign(index, 'center')
        }
      }
    }), _vm._v(" "), _c('alignRight', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(19)
        },
        "textAlign": function($event) {
          _vm.textAlign(index, 'right')
        }
      }
    }), _vm._v(" "), _c('alignJustify', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(20)
        },
        "textAlign": function($event) {
          _vm.textAlign(index, 'justify')
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "btn-group"
    }, [_c('autoScale', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(31)
        },
        "autoScale": function($event) {
          _vm.autoScale(index)
        }
      }
    }), _vm._v(" "), _c('smallCaps', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(32)
        },
        "smallCaps": function($event) {
          _vm.smallCaps(index)
        }
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "m-b-0"
    }, [(_vm.displayType === 'editor') ? _c('li', [_vm._v("\n                                Name: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.name),
        expression: "shape.custom.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (shape.custom.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape.custom, "name", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    })]) : _vm._e(), _vm._v(" "), _c('li', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      class: {
        'col-md-12': (_vm.displayType !== 'designer'), 'col-md-8': (_vm.displayType === 'designer')
      }
    }, [_vm._v("\n                                        " + _vm._s((_vm.$store.state.mode === 'editor') ? 'Default Text:' : '') + "\n                                        "), (_vm.displayType === 'designer' && shape.custom.name.includes('Address')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.text),
        expression: "shape.text"
      }],
      domProps: {
        "value": (shape.text)
      },
      on: {
        "focus": function($event) {
          $event.target.select()
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "text", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.text),
        expression: "shape.text"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (shape.text)
      },
      on: {
        "focus": function($event) {
          $event.target.select()
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "text", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    })]), _vm._v(" "), (_vm.displayType === 'designer' || (_vm.$store.state.mode === 'editor' && shape.custom.autoscale)) ? _c('div', {
      staticClass: "col-md-4"
    }, [(_vm.displayType === 'designer') ? _c('button', {
      staticClass: "btn confirmBtn btn-block m-b-5 m-t-5",
      class: {
        'confirmed': shape.custom.confirmed
      },
      on: {
        "click": function($event) {
          _vm.confirmEdit(index)
        }
      }
    }, [_vm._v(_vm._s((shape.custom.confirmed) ? 'Confirmed' : 'Confirm'))]) : _vm._e(), _vm._v("\n                                        " + _vm._s((_vm.$store.state.mode === 'editor' && shape.custom.autoscale) ? 'Max Width' : '') + "\n                                        "), (_vm.$store.state.mode === 'editor' && shape.custom.autoscale) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.maxWidth),
        expression: "shape.custom.maxWidth"
      }],
      attrs: {
        "type": "text",
        "disabled": shape.custom.autoscale
      },
      domProps: {
        "value": (shape.custom.maxWidth)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape.custom, "maxWidth", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.$store.state.mode === 'editor' && shape.custom.autoscale) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('small', [_vm._v("* To set the autoscale width, please toggle autoscale off and on.")])])]) : _vm._e()]), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings"
    }, [_vm._v("\n                                Format:\n                                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.mask),
        expression: "shape.custom.mask"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shape.custom, "mask", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    }, _vm._l((_vm.formatMasks), function(mask, i) {
      return _c('option', {
        domProps: {
          "value": i
        }
      }, [_vm._v(_vm._s(mask.name))])
    }), 0)]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings m-r-0"
    }, [_vm._v("\n                                Data Attribute:\n                                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.data_attribute),
        expression: "shape.custom.data_attribute"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shape.custom, "data_attribute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("No Data Injection")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "#",
        "disabled": "disabled"
      }
    }, [_vm._v("# Standard Data Attributes ----------")]), _vm._v(" "), _vm._l((_vm.dataAttributes), function(value) {
      return _c('option', {
        attrs: {
          "disabled": value === '# Vendor Data Attributes ----------'
        },
        domProps: {
          "value": (value === '# Vendor Data Attributes ----------') ? '#' : value
        }
      }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("underlineSpace")(value.replace('vendor.', '')))))])
    })], 2)]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings"
    }, [_c('small', {
      staticClass: "right"
    }, [_c('a', {
      attrs: {
        "href": "https://fonts.google.com/",
        "target": "_blank"
      }
    }, [_vm._v("Google Fonts")])]), _vm._v("\n                                Font:\n                                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.fontFamily),
        expression: "shape.fontFamily"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shape, "fontFamily", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    }, _vm._l((_vm.$store.state.fonts), function(font, i) {
      return _c('option', {
        attrs: {
          "data-index": i,
          "disabled": font.name === 'Custom Fonts:' || font.name === 'Google Fonts:' || font.name === '-----------------------' || font.name === ''
        }
      }, [_vm._v("\n                                        " + _vm._s(font.name) + "\n                                    ")])
    }), 0)]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings m-r-0"
    }, [_vm._v("Limit Characters: (0 = unlimited) "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.charLimit),
        expression: "shape.custom.charLimit"
      }],
      attrs: {
        "type": "number",
        "step": "1"
      },
      domProps: {
        "value": (shape.custom.charLimit)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape.custom, "charLimit", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings split"
    }, [_vm._v("Size: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.fontSize),
        expression: "shape.custom.fontSize"
      }],
      attrs: {
        "type": "number",
        "step": "1"
      },
      domProps: {
        "value": (shape.custom.fontSize)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape.custom, "fontSize", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings split"
    }, [_vm._v("Units:\n                                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.fontUnits),
        expression: "shape.custom.fontUnits"
      }],
      attrs: {
        "disabled": shape.custom.autoscale
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shape.custom, "fontUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "px"
      }
    }, [_vm._v("px")]), _vm._v(" "), (!shape.custom.autoscale) ? _c('option', {
      attrs: {
        "value": "pt"
      }
    }, [_vm._v("pt")]) : _vm._e(), _vm._v(" "), (!shape.custom.autoscale) ? _c('option', {
      attrs: {
        "value": "pc"
      }
    }, [_vm._v("pc")]) : _vm._e(), _vm._v(" "), (!shape.custom.autoscale) ? _c('option', {
      attrs: {
        "value": "em"
      }
    }, [_vm._v("em")]) : _vm._e(), _vm._v(" "), (!shape.custom.autoscale) ? _c('option', {
      attrs: {
        "value": "in"
      }
    }, [_vm._v("in")]) : _vm._e(), _vm._v(" "), (!shape.custom.autoscale) ? _c('option', {
      attrs: {
        "value": "mm"
      }
    }, [_vm._v("mm")]) : _vm._e(), _vm._v(" "), (!shape.custom.autoscale) ? _c('option', {
      attrs: {
        "value": "cm"
      }
    }, [_vm._v("cm")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings split"
    }, [_vm._v("Leading: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.lineHeight),
        expression: "shape.lineHeight"
      }],
      attrs: {
        "type": "number",
        "step": "0.10"
      },
      domProps: {
        "value": (shape.lineHeight)
      },
      on: {
        "change": function($event) {
          _vm.updateObject(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "lineHeight", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings split m-r-0"
    }, [_vm._v("Kerning: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.charSpacing),
        expression: "shape.charSpacing"
      }],
      attrs: {
        "type": "number",
        "step": "1"
      },
      domProps: {
        "value": (shape.charSpacing)
      },
      on: {
        "change": function($event) {
          _vm.updateObject(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "charSpacing", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left"
    }, [_vm._v("Fill Color:"), _c('br'), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.fill),
        expression: "shape.fill"
      }],
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (shape.fill)
      },
      on: {
        "change": function($event) {
          _vm.updateObject(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "fill", $event.target.value)
        }
      }
    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor' && (shape.type === 'rect' || shape.type === 'ellipse' || shape.type === 'triangle')) ? _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "btn-group m-r-5"
    }, [(shape.custom.type !== 'clipping-mask') ? _c('editable', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(11)
        },
        "editable": function($event) {
          _vm.editable(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('visible', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(12)
        },
        "visible": function($event) {
          _vm.visible(index)
        }
      }
    }), _vm._v(" "), _c('lock', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(13)
        },
        "lock": function($event) {
          _vm.lock(index)
        }
      }
    })], 1), _vm._v(" "), (shape.custom.type !== 'clipping-mask') ? _c('copy', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(21)
        },
        "clone": function($event) {
          _vm.clone()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Name: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.name),
        expression: "shape.custom.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (shape.custom.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape.custom, "name", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    })]), _vm._v(" "), (shape.custom.type !== 'clipping-mask') ? _c('li', [_vm._v("Stroke: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (shape.strokeWidth),
        expression: "shape.strokeWidth",
        modifiers: {
          "number": true
        }
      }],
      attrs: {
        "type": "number",
        "step": "1"
      },
      domProps: {
        "value": (shape.strokeWidth)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "strokeWidth", _vm._n($event.target.value))
        }, function($event) {
          _vm.updateObject(index, $event)
        }],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e(), _vm._v(" "), (shape.custom.type !== 'clipping-mask') ? _c('li', {
      staticClass: "colorSettings left"
    }, [_vm._v("Fill Color:"), _c('br'), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.fill),
        expression: "shape.fill"
      }],
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (shape.fill)
      },
      on: {
        "change": function($event) {
          _vm.updateObject(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "fill", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "animated fadeInLeft",
        "leave-active-class": "animated fadeOutLeft"
      }
    }, [(shape.custom.type !== 'clipping-mask' && shape.strokeWidth > 0) ? _c('li', {
      staticClass: "colorSettings left"
    }, [_vm._v("Stroke Color:"), _c('br'), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.stroke),
        expression: "shape.stroke"
      }],
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (shape.stroke)
      },
      on: {
        "change": function($event) {
          _vm.updateObject(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "stroke", $event.target.value)
        }
      }
    })]) : _vm._e()])], 1), _vm._v(" "), (_vm.displayType === 'designer') ? _c('button', {
      staticClass: "btn confirmBtn btn-block m-b-5 m-t-5",
      class: {
        'confirmed': shape.custom.confirmed
      },
      on: {
        "click": function($event) {
          _vm.confirmEdit(index)
        }
      }
    }, [_vm._v(_vm._s((shape.custom.confirmed) ? 'Confirmed' : 'Confirm'))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (shape.type === 'image') ? _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "btn-group m-r-5"
    }, [(shape.custom.type !== 'clipping-mask') ? _c('editable', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(11)
        },
        "editable": function($event) {
          _vm.editable(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('visible', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(12)
        },
        "visible": function($event) {
          _vm.visible(index)
        }
      }
    }), _vm._v(" "), _c('lock', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(13)
        },
        "lock": function($event) {
          _vm.lock(index)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "btn-group m-r-5"
    }, [_c('flipx', {
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(24)
        },
        "flipX": function($event) {
          _vm.flipX(index)
        }
      }
    }), _vm._v(" "), _c('flipy', {
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(25)
        },
        "flipY": function($event) {
          _vm.flipY(index)
        }
      }
    })], 1), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Name: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.name),
        expression: "shape.custom.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (shape.custom.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape.custom, "name", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    })]), _vm._v(" "), _c('li', {
      staticClass: "img"
    }, [_c('span', [_vm._v("File Upload:")]), _vm._v(" "), (shape.src) ? _c('img', {
      attrs: {
        "src": shape.src
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "upload-btn-wrapper"
    }, [_c('button', {
      staticClass: "btn btn-success",
      class: {
        'btn-warning': shape.custom.uploadButton !== 'Select Image File'
      }
    }, [_vm._v(_vm._s(shape.custom.uploadButton))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.updateImage(index, $event.target)
        }
      }
    })])]), _vm._v(" "), _c('li', [_vm._v("Scale: " + _vm._s(shape.scaleX * 100) + "% "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.scaleX),
        expression: "shape.scaleX"
      }],
      attrs: {
        "type": "range",
        "min": "0",
        "max": "1",
        "step": "0.01"
      },
      domProps: {
        "value": (shape.scaleX)
      },
      on: {
        "change": function($event) {
          _vm.updateObject(index, $event)
        },
        "__r": function($event) {
          _vm.$set(shape, "scaleX", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', [_vm._v("\n                                Clipping Mask:\n                                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.clipto),
        expression: "shape.custom.clipto"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shape.custom, "clipto", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.applyMask(index, $event.target.value, true, false)
        }]
      }
    }, [_c('option', {
      attrs: {
        "data-index": -1,
        "value": "-1"
      }
    }, [_vm._v("No Clipping Mask")]), _vm._v(" "), _vm._l((_vm.clippingMasks), function(mask, i) {
      return _c('option', {
        domProps: {
          "value": i
        }
      }, [_vm._v("\n                                        " + _vm._s(mask.custom.name) + "\n                                    ")])
    })], 2)]) : _vm._e()]), _vm._v(" "), (_vm.displayType === 'designer') ? _c('button', {
      staticClass: "btn confirmBtn btn-block m-b-5 m-t-5",
      class: {
        'confirmed': shape.custom.confirmed
      },
      on: {
        "click": function($event) {
          _vm.confirmEdit(index)
        }
      }
    }, [_vm._v(_vm._s((shape.custom.confirmed) ? 'Confirmed' : 'Confirm'))]) : _vm._e()]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), (_vm.displayType === 'editor') ? _c('div', {
    staticClass: "panel panel-default m-b-20"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-test",
      "href": "#collapse100",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "icon-image m-r-5"
  }), _vm._v("\n                            Background & Margins\n                            "), _c('i', {
    staticClass: "icon-lock right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    staticStyle: {
      "height": "0px"
    },
    attrs: {
      "id": "collapse100",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ul', [_c('li', {
    staticClass: "left sizeSettings",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(23)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(23)
      }
    }
  }, [_vm._v("Safe Area: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prodSafe),
      expression: "prodSafe"
    }],
    attrs: {
      "type": "number",
      "step": "0.001",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.prodSafe)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.prodSafe = $event.target.value
      }, function($event) {
        _vm.setSafe($event.target.value)
      }]
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "left sizeSettings m-r-0",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(22)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(22)
      }
    }
  }, [_vm._v("Trim: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prodBleed),
      expression: "prodBleed"
    }],
    attrs: {
      "type": "number",
      "step": "0.001",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.prodBleed)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.prodBleed = $event.target.value
      }, function($event) {
        _vm.setTrim($event.target.value)
      }]
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "img"
  }, [_c('span', [_vm._v("File Upload:")]), _vm._v(" "), (_vm.$store.state.template.files[_vm.$store.state.activeTemplate].json && _vm.$store.state.template.files[_vm.$store.state.activeTemplate].json.backgroundImage && _vm.$store.state.template.files[_vm.$store.state.activeTemplate].json.backgroundImage.src) ? _c('img', {
    attrs: {
      "src": _vm.$store.state.template.files[_vm.$store.state.activeTemplate].json.backgroundImage.src
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Select Image File")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.updateBackground($event.target)
      }
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'designer' && this.proceed.show !== false) ? _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    }
  }, [(_vm.$store.state.savedTemplate !== null) ? _c('button', {
    key: 0,
    staticClass: "btn block btn-md waves-effect waves-light saveButtons btn-success m-t-10",
    staticStyle: {
      "font-size": "1.1em",
      "padding": "8px 0"
    },
    attrs: {
      "disabled": (!_vm.templateName || _vm.$store.state.savedTemplate.id === this.$store.state.template.id),
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateExistingTemplate(_vm.loadNextTemplate, $event)
      }
    }
  }, [_vm._v("\n                    " + _vm._s((_vm.$store.state.savedTemplate.id !== this.$store.state.template.id) ? 'Save & Continue' : 'Loading, Please Wait..') + "\n                ")]) : _c('button', {
    key: 1,
    staticClass: "btn block btn-md waves-effect waves-light saveButtons btn-success m-t-10",
    staticStyle: {
      "font-size": "1.1em",
      "padding": "8px 0"
    },
    attrs: {
      "disabled": !_vm.templateName,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveAsNewTemplate(_vm.loadNextTemplate, $event)
      }
    }
  }, [_vm._v("\n                    Save & Continue\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'designer' && this.proceed.show === false) ? _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    key: 0,
    staticClass: "noEdit m-t-20"
  }, [_vm._v("\n                    Please confirm all fields to continue.\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('div', {
    staticClass: "panel panel-default m-b-20"
  }, [_c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.toggleShortcuts()
      }
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "icon-keyboard m-r-5"
  }), _vm._v("\n                        Keyboard Shortcuts\n                    ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [(_vm.shortcuts) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table m-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Shortcut")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Shift")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Holding shift while dragging will lock the object so that it can only move up and down.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Command  ")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Holding command while dragging will lock the object so that it can only move left and right.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("⇦"), _c('br'), _vm._v("Shift + ⇦"), _c('br'), _vm._v("Option + ⇦")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Move object 1 pixel left."), _c('br'), _vm._v("\n                                        Holding shift will move 10 pixels at a time."), _c('br'), _vm._v("\n                                        Holding option will move 25 pixels at a time.\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("⇨"), _c('br'), _vm._v("Shift + ⇨"), _c('br'), _vm._v("Option + ⇨")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Move object 1 pixel right."), _c('br'), _vm._v("\n                                        Holding shift will move 10 pixels at a time."), _c('br'), _vm._v("\n                                        Holding option will move 10 pixels at a time.\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("⇧"), _c('br'), _vm._v("Shift + ⇧"), _c('br'), _vm._v("Option + ⇧")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Move object 1 pixel up."), _c('br'), _vm._v("\n                                        Holding shift will move 10 pixels at a time."), _c('br'), _vm._v("\n                                        Holding option will move 10 pixels at a time.\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("⇩"), _c('br'), _vm._v("Shift + ⇩"), _c('br'), _vm._v("Option + ⇩")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Move object 1 pixel down."), _c('br'), _vm._v("\n                                        Holding shift will move 10 pixels at a time."), _c('br'), _vm._v("\n                                        Holding option will move 10 pixels at a time.\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Delete ⌦")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Deletes object from canvas\n                                    ")])])])])]) : _vm._e()])], 1) : _vm._e()], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c228fa6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Canvas.vue
// module id = 323
// module chunks = 0